import { type AriaSnackbarProps } from '@hh.ru/magritte-ui-snackbar/types';

interface UseAriaSnackbarProps extends AriaSnackbarProps {
    hasAction: boolean;
}

interface AriaAttributes extends AriaSnackbarProps {
    'aria-describedby'?: string;
    'aria-modal'?: 'true' | 'false';
    tabIndex?: number;
}

export const useAriaSnackbar = ({ role, 'aria-label': ariaLabel, hasAction }: UseAriaSnackbarProps): AriaAttributes => {
    let ariaAttributes: AriaAttributes = {
        role,
        'aria-label': ariaLabel,
    };

    if (hasAction || role === 'alertdialog') {
        ariaAttributes = {
            ...ariaAttributes,
            role: 'alertdialog',
            'aria-modal': 'true',
            tabIndex: 0,
        };
    }

    if (role !== 'status') {
        ariaAttributes = {
            ...ariaAttributes,
            'aria-describedby': 'dialog-description',
        };
    }

    return ariaAttributes;
};
